const selectors = {
  root: ":root",

  header: "[data-header]",

  faq: "[data-faq]",
  faqItem: "[data-faq-item]",

  faqNav: "[data-faq-nav]",
  faqGroup: "[data-faq-group]",
  faqAnchor: "[data-faq-anchor]",
};

const setScrollPadding = (value: number) => {
  const root = document.querySelector(selectors.root) as HTMLElement;

  root.style.setProperty("--scroll-padding-top", value + "px");
};

const initFAQNavigation = (nav, anchors, groups) => {
  const header = document.querySelector(selectors.header) as HTMLElement;
  const headerHeight = header?.clientHeight ?? 0;
  const navHeight = matchMedia("(max-width: 1024px)").matches ? nav?.clientHeight : 0;
  const scrollPadding = headerHeight + navHeight;

  anchors = anchors.map((element) => ({
    id: decodeURI(element.hash).slice(1),
    element: element,
  }));

  const observer = new IntersectionObserver(
    () => {
      const firstVisibleBlock = groups.find(
        (group) => group.getBoundingClientRect().top >= scrollPadding
      );

      anchors.forEach((link) =>
        link.element.setAttribute(
          "data-faq-anchor",
          firstVisibleBlock && link.id === firstVisibleBlock.id
        )
      );
    },
    {
      root: null,
      rootMargin: `-${scrollPadding}px 0px 0px`,
      threshold: [0, 1],
    }
  );

  groups.forEach((group) => observer.observe(group));
  nav.style.setProperty("--faq-nav-top", headerHeight + "px");
  setScrollPadding(scrollPadding);
};

const initFAQBlock = (faq) => {
  const nav = faq.querySelector(selectors.faqNav);
  const items = faq.querySelectorAll(selectors.faqItem);
  const anchors = faq.querySelectorAll(selectors.faqAnchor);
  const groups = faq.querySelectorAll(selectors.faqGroup);

  items.forEach((item, activeIndex) => {
    item.firstElementChild.addEventListener("click", () => {
      items.forEach((item, index) => {
        const isActive = item.dataset.faqItem === "active";

        item.setAttribute("data-faq-item", isActive ? "" : activeIndex === index ? "active" : "");
      });
    });
  });

  anchors.length && initFAQNavigation(nav, [...anchors], [...groups]);
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const faqs = document.querySelectorAll(selectors.faq);

    faqs?.forEach(initFAQBlock);
  },
  {
    once: true,
  }
);
